import React from "react";
import { Card, Image, Spinner, Placeholder } from "react-bootstrap";
import TeamWork from "../../../../assets/img/teamwork.png";
import Properties from "../../../../assets/img/properties.png";
import Income from "../../../../assets/img/salary.png";
import Tenants from "../../../../assets/img/tenats.png";
import { useGetCompanyPropertyDetailsQuery } from "../../lib/apiSlice/property/propertySlice.tsx";

export default function AllPropertyMetrics() {
    const { data, isLoading } = useGetCompanyPropertyDetailsQuery();
    const companyDetails = data?.results?.[0] || {};

    return (
        <div className="staticCards d-flex justify-content-start mt-5">
            <Card className="w-25 rentDue">
                <Card.Body>
                    <Image src={TeamWork} />
                    <div className="float-left">
                        <span>Total Property Managers</span>
                        <div className="d-flex mt-2">
                            {isLoading ? (
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={6} />
                                </Placeholder>
                            ) : (
                                <p>{companyDetails ? companyDetails.total_landlords : "0"} Account(s)</p>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Card className="w-25 defaulters">
                <Card.Body>
                    <Image src={Properties} />
                    <div className="float-left">
                        <span className="defaultersText">Total Properties</span>
                        {isLoading ? (
                            <Placeholder as="p" animation="glow">
                                <Placeholder xs={6} />
                            </Placeholder>
                        ) : (
                            <p className="defaultersText">{companyDetails ? companyDetails.total_properties : '0'} Properties</p>
                        )}
                    </div>
                </Card.Body>
            </Card>

            <Card className="w-25 income">
                <Card.Body>
                    <Image src={Income} />
                    <div className="float-left">
                        <span>Total Expected Income</span>
                        <div className="d-flex mt-2">
                            {isLoading ? (
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={6} />
                                </Placeholder>
                            ) : (
                                <p className="">KSH. {companyDetails ? companyDetails.total_expected_rent?.toLocaleString('en-US') : '0'}</p>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Card className="w-25 occupacy">
                <Card.Body>
                    <Image src={Tenants} />
                    <div className="float-left">
                        <span>Total Tenants</span>
                        <div className="d-flex mt-2">
                            {isLoading ? (
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={6} />
                                </Placeholder>
                            ) : (
                                <p className="">{companyDetails ? companyDetails.total_active_tenants : '0'} tenant(s)</p>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
}